import { useCallback, useEffect, useState } from 'react';
import { sfx } from '../audio/sfx';

/**
 * Le reglage son, meme parti pris que le theme : persiste, mais jamais
 * impose. Par defaut actif — c'est la demande — mais une table bruyante
 * ou un stream doivent pouvoir le couper en un geste.
 */
const KEY = 'guess:sound';

function read(): boolean {
  try {
    const saved = window.localStorage.getItem(KEY);
    if (saved === 'off') return false;
  } catch {
    /* navigation privee : le son reste actif pour cette session */
  }
  return true;
}

function write(on: boolean): void {
  try {
    window.localStorage.setItem(KEY, on ? 'on' : 'off');
  } catch {
    /* sans importance */
  }
}

export function useSound(): { on: boolean; toggle: () => void } {
  const [on, setOn] = useState<boolean>(read);

  useEffect(() => {
    sfx.setMuted(!on);
    write(on);
  }, [on]);

  const toggle = useCallback(() => setOn((v) => !v), []);

  return { on, toggle };
}
